import React, { useCallback, useMemo, useState } from "react";
import AggregationWidgetExportDropdown from "search/ExportWidgetAction/AggregationWidgetExportDropdown";
import { MenuItem } from "components/bootstrap";
import useWidgetResults from "views/components/useWidgetResults";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useView from "views/hooks/useView";
import useSearchExecutionState from "views/hooks/useSearchExecutionState";
import usePluginEntities from "hooks/usePluginEntities";
import { defaultCompare } from "logic/DefaultCompare";
import downloadByExportStrategy from "search/ExportWidgetAction/downloadByExportStrategy";
import useCurrentUser from "hooks/useCurrentUser";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
const ExportOverviewWidgetsActionComponent = ({ widget, disabled }) => {
  const [isExporting, setIsExporting] = useState(false);
  const { error: errors, widgetData: widgetResult } = useWidgetResults(widget.id);
  const view = useView();
  const showExportAggregationWidgetAction = widgetResult && !(errors == null ? void 0 : errors.length);
  const executionState = useSearchExecutionState();
  const sendTelemetry = useSendTelemetry("search-widget");
  const currentQuery = useCurrentQuery();
  const currentUser = useCurrentUser();
  const exportFormats = usePluginEntities("views.export.formats");
  const exportFormatOptions = useMemo(
    () => exportFormats.sort((type1, type2) => defaultCompare(type1 == null ? void 0 : type1.displayName, type2 == null ? void 0 : type2.displayName)).map(({ type, displayName, disabled: disabledFn = () => false }) => {
      const isDisabled = disabledFn();
      const title = displayName();
      return { title, id: type, disabled: isDisabled };
    }),
    [exportFormats]
  );
  const onExportWidget = useCallback(
    (extension) => {
      setIsExporting(true);
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.EXPORT, {
        app_action_value: { extension }
      });
      return downloadByExportStrategy({
        widget,
        widgetResult,
        currentUser,
        extension,
        view,
        currentQuery,
        executionState
      }).finally(() => setIsExporting(false));
    },
    [sendTelemetry, widget, widgetResult, currentUser, view, currentQuery, executionState]
  );
  return showExportAggregationWidgetAction && /* @__PURE__ */ React.createElement(AggregationWidgetExportDropdown, { isExporting }, exportFormatOptions.map(({ id: extension, title: extensionTitle, disabled: optionDisabled }) => /* @__PURE__ */ React.createElement(MenuItem, { disabled: disabled || optionDisabled, key: extension, onSelect: () => onExportWidget(extension) }, extensionTitle)));
};
export default ExportOverviewWidgetsActionComponent;
